import type { PipelineStageDisplay } from '@/components/submission/StatusPipeline';

export interface CanonicalLifecycleStage {
  readonly key: string;
  readonly label: string;
}

/**
 * The single source of truth for the submission lifecycle stage list.
 * Keys + labels match the backend `computeStatusSnapshot()` output so a
 * backend-driven snapshot and a status-derived list render identically.
 */
export const CANONICAL_LIFECYCLE_STAGES: readonly CanonicalLifecycleStage[] = [
  { key: 'draft', label: 'Submission created' },
  { key: 'documents', label: 'Documents uploaded' },
  { key: 'classified', label: 'Classified' },
  { key: 'confirmed', label: 'Confirmed' },
  { key: 'validated', label: 'Validated' },
  { key: 'compiled', label: 'Compiled' },
  { key: 'submitted-to-agency', label: 'Submitted to Agency' },
];

/** No completion claims while the canonical evidence is unavailable. */
export function unavailableLifecycleStages(detail: string): PipelineStageDisplay[] {
  return CANONICAL_LIFECYCLE_STAGES.map((stage) => ({
    ...stage, label: stage.key === 'validated' ? 'Validation' : stage.label,
    state: 'pending', detail,
  }));
}
